import { useState, useEffect } from 'react';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

const PATH = 'artifacts/bz-tracker/appSettings/aiConfig';

const DEFAULTS = {
  defaultProvider: 'gemini',
  defaultModel: 'gemini-3-flash-preview',
  fallback: [],
  allowUserModelSelection: true,
};

/** Admin-managed org-wide AI policy (appSettings/aiConfig). */
export const useAIPolicy = () => {
  const [policy, setPolicy] = useState(DEFAULTS);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!db) {
      setIsLoading(false);
      return undefined;
    }
    const ref = doc(db, PATH);
    return onSnapshot(
      ref,
      (snap) => {
        setPolicy(snap.exists() ? { ...DEFAULTS, ...snap.data() } : DEFAULTS);
        setIsLoading(false);
      },
      () => setIsLoading(false)
    );
  }, []);

  const updatePolicy = async (next, userId) => {
    if (!db) throw new Error('Database not available');
    await setDoc(
      doc(db, PATH),
      {
        defaultProvider: next.defaultProvider,
        defaultModel: next.defaultModel,
        allowUserModelSelection: next.allowUserModelSelection,
        fallback: next.fallback || [],
        updatedAt: serverTimestamp(),
        updatedBy: userId || null,
      },
      { merge: true }
    );
  };

  return { policy, isLoading, updatePolicy };
};
